import { nodePath } from 'Config/path.js';
import { fetchGet } from 'Services/fetchService.js';

export default async (taskId) => {
    const response = await fetchGet(`${nodePath}/comments/users?taskId=${taskId}`);

    return response?.length ? response : [];
}
